import queryString from 'query-string'

import { getAuthenticityToken } from 'Shared/helpers'
import { MAX_ALLOWED_SELECTED_LEAGUES } from '../constants'
import FetcherFactory from 'Shared/FetcherFactory'

export const reducerName = 'ENHANCED_LEAGUES'

const factory = new FetcherFactory(
  reducerName,
  ({ params, state, dispatch, factory }) => {

    const serializedParams = queryString.stringify(params, { arrayFormat: 'bracket' })
    const serializedQueryString = new URLSearchParams(serializedParams).toString()

    return fetch(`${state.baseURL}?${serializedQueryString}`, {
      method: 'GET',
      credentials: 'same-origin',
      headers: {
        'X-CSRF-Token': getAuthenticityToken(),
        'Content-Type': 'application/json',
      },
    }).then(response => {
      return response.json().then(data => {
        return ({
          data: data,
          status: response.status,
        })
      })
    })
  },
  {
    baseParams: {
      extra_attributes: [ 'rounds', 'has_stripe_account', 'has_registration_payment_options', 'golf_hub_page', 'has_managers' ],
      per_page: MAX_ALLOWED_SELECTED_LEAGUES,
    },
  },
)

const getInitialState = ({ searchLeaguesURL, enhancedLeagues }) => {
  return {
    data: {
      leagues: enhancedLeagues,
    },
    baseURL: searchLeaguesURL,
  }
}

const enhancedLeaguesReducer = factory.getReducer()
const fetchEnhancedLeagues = factory.getFetchAction()

const fetchEnhancedLeaguesFromList = (targetLeaguesIDs) =>
  fetchEnhancedLeagues({
    'current_active_filters[filter_by_ids]': targetLeaguesIDs,
  })


const selectEnhancedLeaguesLoading = state => state[factory.name]?.loading
const selectEnhancedLeagues = state => state[factory.name]?.data?.leagues

const namedReducer = {[factory.name]: enhancedLeaguesReducer}

export {
  getInitialState,
  namedReducer,
  fetchEnhancedLeaguesFromList,
  selectEnhancedLeagues,
  selectEnhancedLeaguesLoading,
}
